import HeroCarousel from "../components/HeroCarousel";
import VIP from "../components/VIP";
import AboutUsSection from "../components/AboutSection";
import LatestNewsMarquee from "./LatestNewsMarquee";
import EventsSection from "./EventsSection";
import QuickButton from "../components/QuickButton";
import Facilities from "../components/Facilities";
import CTA from "../components/CTA";
import GallerySlide from "../components/GallerySlide";
import { useSelector } from "react-redux";
import "./Doc.css";
import VideoSection from "../components/VideoSection";
import img1 from "../assets/anandiben.png"
import img2 from "../assets/yogi.png"
import img3 from "../assets/Yogendra.png"
import img4 from "../assets/rajini.png"

function Home() {
  const store = useSelector((state) => state.auth.store);

  const { videos, hasVideoSection } = useSelector((state) => state.auth);

  const quicklinks = [
    {
      name: "Exams",
      image: "https://thenounproject.com/browse/icons/term/online-exam/",
    },
    {
      name: "Admissions",
      image: "https://content.acetians.in/uploads/admission%20(1).png",
    },
    {
      name: "Results",
      image: "https://content.acetians.in/uploads/rankings.png",
    },
    {
      name: "Students",
      image: "http://content.acetians.in/uploads/education%20(1).png",
    },
    {
      name: "University",
      image: "https://content.acetians.in/uploads/mortarboard.png",
    },
    {
      name: "Academics",
      image: "https://content.acetians.in/uploads/academic.png",
    },
  ];

  const events = [
    {
      title: "पाँच दिवसीय रोवर्स-रेंजर्स प्रशिक्षण एवं जांच शिविर काआयोजन",
      link: "#",
      image: "#",
      date: "March 11, 2024",
    },
    {
      title:
        "राष्ट्रीय सेवा योजना के अंतर्गत सप्तदिवसीय विशेष शिविर संबंधित सूचना",
      link: "#",
      image: "#",
      date: "February 19, 2024",
    },
  ];

  const nextEvents = [
    {
      title: "पाँच दिवसीय रोवर्स-रेंजर्स प्रशिक्षण एवं जांच शिविर काआयोजन",
      link: "#",
      date: "March 11, 2024",
    },
    {
      title:
        "राष्ट्रीय सेवा योजना के अंतर्गत सप्तदिवसीय विशेष शिविर संबंधित सूचना",
      link: "#",
      date: "February 19, 2024",
    },
    {
      title: "Job Fair from Regional Employment Office Gorakhpur",
      link: "#",
      date: "April 22, 2023",
    },
  ];

  const vipList = [
    {
      name: "Smt. Anandiben Mafatbhai Patel",
      Role: "Hon’ble Chancellor & H.E. Governor of U.P.",
      img: img1,
    },
    {
      name: "Sri Yogi Adityanath Ji",
      Role: "Hon’ble Chief Minister of U.P.",
      img: img2
    },
    {
      name: "Sri Yogendra Upadhyay",
      Role: "Higher Education Minister",
      img: img3,
    },
    {
      name: "Smt. Rajni Tiwari",
      Role: "Minister of State (Higher Education)",
      img: img4,
    },
  ];

  return (
    <div>
      <div className="d-flex w-100" style={{ maxWidth: "100vw" }}>
        <div className="col-md-9 p-0" style={{ padding: 0 }}>
          <HeroCarousel />
        </div>
        <div className="col-md-3">
          <ul style={{ padding: "0px", margin: "0px" }}>
            {vipList.map((vip) => (
              <VIP key={vip.name} chancellor={vip} />
            ))}
          </ul>
        </div>
      </div>
      <LatestNewsMarquee item={store.marquee} />

      <ul id="quicklinks-ul">
        {quicklinks.map((link, index) => (
          <QuickButton key={index} link={link} />
        ))}
      </ul>

      <AboutUsSection
        title="Welcome to"
        subtitle={store.store_title.split("=")[0]}
        description={store.about_page}
        eContentLink="/e-pathshalas/"
        feedbackLink="#"
        path={"/about/about-us"}
        imageUrl={"https://campus.acetians.in/custom/images/20240906-img1.jpeg"}
      />

      <EventsSection events={events} nextEvents={nextEvents} />
      <AboutUsSection
        title="PRINCIPAL"
        name={`Prof. (Dr.) ${store.principal_name}`}
        path={"/administration/principals-message"}
        subtitle="MESSAGE"
        // description={`${store.principal_message}`}
        description={store.principal_message}
        eContentLink=""
        feedbackLink=""
        imageUrl={`https://campus.acetians.in/custom/images/${store.principal_image}`}
        readMore={true}
      />
      <Facilities />

      {hasVideoSection ? <VideoSection videos={videos} /> : ""}



     
     <div className="callouts-wrapper" style={{paddingBottom:"50px"}}>
      <div className="container my-2 p-6" style={{ paddingBottom: "20px" }}> 
        <div className="row d-flex p-2">
            <h2 >Our College Events</h2>
          <div className="col-md-4 p-2 mt-4">
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                className="card p-  shadow-sm"
              >
                <img
                  alt=""
                  src="https://campus.acetians.in/custom/images/rover1.png"
                  style={{ width: "200px",height:"200px" }}
                />
                <p
                  style={{
                    textAlign: "center",
                    fontWeight: 400,
                    fontSize: 20,
                    marginTop: 10,
                  }}
                >
                  Rover Rangers
                </p>
                <a
                  className="btn btn-secondary-outlined btn-block visit"
                  href="/events/rover-rangers"
                >
                  Visit
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4 p-2">
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                className="card p-3 shadow-sm"
              >
                <img
                  alt=""
                  src="https://campus.acetians.in/custom/images/nss1.png"
                  style={{ width: "200px",height:"200px" }}
                />
                <p
                  style={{
                    textAlign: "center",
                    fontWeight:400,
                    fontSize: 20,
                    marginTop: 10,
                  }}
                >
                  Community Outreach Programs(NSS)
                </p>
                <a
                  className="btn btn-secondary-outlined btn-block visit"
                  href="/events/nss"
                   
                >
                  Visit
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4 p-2">
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                className="card p-3 shadow-sm"
              >
                <img
                  alt=""
                  src="https://campus.acetians.in/custom/images/green-globe.png"
                   style={{ width: "200px",height:"200px",borderRadius:"50%" }}
                />
                <p
                  style={{
                    textAlign: "center",
                    fontWeight: 400,
                    fontSize: 22,
                    marginTop: 10,
                  }}
                >
                  Green Globe Club
                </p>
                <a
                  className="btn btn-secondary-outlined btn-block visit"
                  href="/events/green-globe-club"
                  
                >
                  Visit
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <CTA />

      <GallerySlide />
    </div>
  );
}

export default Home;
